import React from "react";
import { BsMusicNoteBeamed, BsPersonFill } from "react-icons/bs";
import { Animate } from "react-simple-animate";
import "./styles.scss";

const qawalis = [
  { title: "Hazrat -E- Adam Ka Waqiya.", qawaliKhawan: "Mohammad Rafi", audioSrc: "qawali/q1.mp3" },
  { title: "Hazrat -E- Nooh Ka Waqiya.", qawaliKhawan: "Mohammad Rafi", audioSrc: "qawali/q2.mp3" },
  { title: "Dawate Rasool(SAW) Ka Waqiya.", qawaliKhawan: "Mohammad Rafi", audioSrc: "qawali/q3.mp3" },
  { title: "Aye Momino Suno Karamat Namaz Ki", qawaliKhawan: "Muhammad Aziz", audioSrc: "qawali/q4.mp3" },
  { title: "Tu Kuja Man Kuja", qawaliKhawan: "Hafiz Ahmed Raza Qadri", audioSrc: "qawali/q5.mp3" },

];

const Qawali = () => {
  return (
    <section id="qawali-page" className="qawali-page">
        <video autoPlay loop muted className="background-video">
        <source src="video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="qawali-grid">
        {qawalis.map((qawali, index) => (
          <Animate
            key={index}
            play
            duration={1.5}
            delay={0.2 * index}
            start={{ opacity: 0, transform: "translateY(-20px)" }}
            end={{ opacity: 1, transform: "translateY(0px)" }}
          >
            <div className="qawali-container">
              <h2 className="qawali-title">
                <BsMusicNoteBeamed size={30} /> {qawali.title}
              </h2>
              <p className="qawali-khawan">
                <BsPersonFill size={20} /> {qawali.qawaliKhawan}
              </p>
              <div className="audio-player">
                <audio controls>
                  <source src={qawali.audioSrc} type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>
              </div>
            </div>
          </Animate>
        ))}
      </div>
    </section>
  );
};

export default Qawali;
